<template>
  <b-row class="main-container service-props m-t-90 m-b-90 ">
    <b-col
      v-for="(item, i) in items"
      :key="i"
      lg="3"
      md="6"
      sm="12"
    >
      <div class="d-flex justify-content-between m-b-20">
        <h3 class="title text-primary font-weight-bold black-1 mb-0">
          <span class="header-letter-first main-blue">{{ item.firstLetter }}</span>
          <span
            class="header-letter text-lowercase"
          >{{ item.title }}</span>
        </h3>
        <div>
          <img
            :src="item.iconSrc"
            alt="props"
          >
        </div>
      </div>
      <p class="f-s-14 grey-dark">
        {{ item.context }}
      </p>
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'ServiceProps',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.col-padding {
  padding: 0 34px !important;
}

.service-props {
  background: #FFFFFF;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  min-height: 200px;
  padding: 36px 23px 31px 30px;
}

.title {
  min-width: 120px;
  font-size: 14px;
  padding: 0 !important;
  letter-spacing: 0.175em;
  position: relative;

  .header-letter {
    position: absolute;
    bottom: -3px;

    &-first {
      font-size: 18px !important;
      border-bottom: 3px solid #d7e3fc;
    }
  }
}
</style>
